<template>
  <BaseTagInputText v-bind="style"
                    v-on="$listeners"
                    v-model="input"
                    :inputContainerStyle="inputContainerStyle"
                    :inputStyle="inputStyle"
                    :suggested="suggested"
                    :tags="tags"
                    :tagStyle="tagStyle"
                    @add-tag="addTagByEnter"
                    @clear="clearInput"
                    @click-outside="() => { focus = false; }"
                    @focusin="() => { focus = true; }"
                    @focusout="() => {}"
                    @pop-tag="popTag"
                    @remove-tag="removeTag">
    <template v-slot:popover>
      <SearchExpertBoxPopover :errorMessage="errorMessage"
                              :hideText=true
                              :input="input"
                              :showSearchByName=false
                              :suggestions="suggestions"
                              @add-tag="addTag" />
    </template>
  </BaseTagInputText>
</template>

<script>
  import BaseTagInputText from '@base/base-tag-input-text'
  import SearchExpertBoxPopover from '@modules/search-box/search-expert-box-popover'
  import axios from 'axios'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'
  import { isEquivalentSkillName, toHalfWidth } from '@js/str-utils'

  export default {
    name: 'TagInputSkill',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'tags-change',
    },
    components: {
      BaseTagInputText,
      SearchExpertBoxPopover,
    },
    props: {
      vmodelValue: { type: Array },
      excludes: { type: Array, required: false, default: () => [] },
      initInput: { type: String, required: false, default: '' },
      initTags: { type: Array, required: false, default: () => [] },
      inputMinWidth: { type: String, required: false, default: '120px', },
    },
    data: function () {
      return {
        errorMessage: '',
        input: '',
        inputContainerStyle: {
          padding: '0 0 0 8px',
        },
        inputStyle: {
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.md,
          margin: '0 0 0 8px',
          minWidth: this.inputMinWidth,
        },
        focus: false,
        suggestions: [],
        tags: [],
        tagStyle: {
          borderRadius: '4px',
          fontSize: FontStyle.size.sm,
          fontWeight: FontStyle.weight.lg,
          height: '18px',
          margin: '0 0 0 8px',
          padding: '0 8px',
        },
      };
    },
    created: function () {
      this.input = this.initInput;
      this.tags = this.initTags ? this.initTags : this.vmodelValue;

      this.inputContainerStyle = {
        ...this.inputContainerStyle,
      };

      this.inputStyle = {
        ...this.inputStyle,
        color: {
          '': this.color.dark2(),
          disabled: this.color.dark3(),
          placeholder: this.color.dark3(),
        },
      };

      this.tagStyle = {
        ...this.tagStyle,
        backgroundColor: this.color.dark3(),
        color: this.color.light1(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      style: function () {
        return {
          backgroundColor: {
            '': this.color.light1(),
            disabled: this.color.shadow1(),
          },
          border: {
            '': null,
            disabled: `solid ${this.color.dark5()}`,
          },
          borderRadius: '8px',
          borderWidth: { '': null, disabled: '1px' },
          boxShadow: {
            '': '0 4px 16px rgba(0, 0, 0, 0.2)',
            hover: '0 4px 16px rgba(0, 0, 0, 0.25)',
            focus: '0 4px 16px rgba(0, 0, 0, 0.25)',
          },
          height: '36px',
          width: '100%',
          ...this.$attrs,
        };
      },
      suggested: function () {
        return this.focus && this.input.length > 0;
      },
    },
    methods: {
      addTagByEnter: function (newTag, byEnter = false) {
        const duplicates = this.tags.filter(
            tag => isEquivalentSkillName(tag, newTag));
        if (duplicates.length > 0) {
          this.errorMessage = 'Duplciate(s) exists.';
          return;
        }

        const excludes = this.excludes.filter(
            tag => isEquivalentSkillName(tag, newTag));
        if (excludes.length > 0) {
          this.errorMessage = `${newTag} can not be added.`;
          return;
        }

        this.tags.push(toHalfWidth(newTag).trim());
        this.input = '';
        this.$emit('tags-change', this.tags);
      },
      addTag: function (newTag) {
        this.addTagByEnter(newTag);
        this.focus = false;
      },
      clearInput: function () {
        this.input = '';
        this.tags = [];
        this.$emit('tags-change', this.tags);
      },
      popTag: function () {
        this.input = this.tags.length > 0 ? this.tags.pop() : '';
        this.$emit('tags-change', this.tags);
      },
      removeTag: function (tagIndex) {
        this.tags.splice(tagIndex, 1);
        this.$emit('tags-change', this.tags);
      },
    },
    watch: {
      input: async function (newVal, oldVal) {
        this.errorMessage = '';
        try {
          this.suggestions = await this.$store.dispatch(
            'skills/fetchSkillSuggestions', newVal);
        } catch (error) {
          if (!axios.isCancel) {
            console.error(error);
          }
        }
      },
      vmodelValue: function (newVal, oldVal) {
        this.tags = newVal;
      },
    },
  };

</script>
